// extracted by mini-css-extract-plugin
export default {"cards":"yU3TOQQw7SJiNMwUaJ__"};